export function EcoNoticeCard() {
  return (
    <section className="bg-surface-low rounded-4 p-3 d-flex align-items-center gap-3 d-lg-none">
      <div
        className="rounded-circle bg-surface-lowest d-flex align-items-center justify-content-center text-success flex-shrink-0"
        style={{ width: 40, height: 40 }}
      >
        <i className="bi bi-recycle" />
      </div>
      <div className="d-flex flex-column">
        <span className="text-label-md text-on-surface">Zero Waste Smart Queue</span>
        <span className="text-body-sm text-on-surface-variant">
          The printer is preheated and ready. Output starts instantly once payment completes.
        </span>
      </div>
    </section>
  );
}
